import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Button from 'ui/Button';
import EmptyState from 'ui/EmptyState';

type Props = {
  drawerRef: React.RefObject<HTMLDivElement>;
};

const SignUpToAddBrandingInfo: React.FC<Props> = ({ drawerRef }) => {
  const { openSignUpModal } = useGlobalModalsContext();
  return (
    <EmptyState
      icon="palette"
      title="Sign up to add your own branding"
      description="Save your brand colors, making them readily available when working on your diagrams."
      px={0}
      pt={0}
      h="100%"
    >
      <Button variant="primary-solid" onClick={openSignUpModal}>
        Sign up for free
      </Button>
    </EmptyState>
  );
};

export default SignUpToAddBrandingInfo;
